import { ChangeEvent, Dispatch, FocusEvent, SetStateAction } from 'react';
import { DateValidationError } from '@mui/x-date-pickers/internals';
import { Field } from '../models/home';
import { REGEX, VALIDATION_TYPE } from '../constants/common';
import { SelectChangeEvent } from '@mui/material';

const getEmailErrorText = (
    errorMsg: string,
    errorMatchMsg: string,
    otherFieldIndex: number,
    otherFieldValue: string,
    value: string
) => {
    if (value) {
        if (
            !value.match(REGEX.email) 
            || value.includes('..')
            || value.includes('.@')
            || value.includes('@.')
        ) {
            return errorMsg;
        }
        if (
            otherFieldIndex === 2
            && otherFieldValue
            && otherFieldValue.toLowerCase() !== value.toLowerCase()
            && errorMatchMsg
        ) {
            return errorMatchMsg;
        }
        return '';
    }
    return '';
};

export const handleOnBlur = (
    event: FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>,
    index: number, 
    length: number,
    validationErrorText: string,
    setFields: Dispatch<SetStateAction<Field[]>>
) => {
    if (event.target.value && event.target.value.length !== length) {
        setFields(prevState => {
            const updatedState = prevState.map((s, i) => {
                if (i === index) {
                    return {
                        ...s,
                        error: validationErrorText
                    }
                }
                return s; 
            })
            return updatedState;
        })
    };
};

export const handleOnChangeDate = (
    newValue: false | '' | Date | null,
    index: number,
    setFields: Dispatch<SetStateAction<Field[]>>,
    otherIndexesRequiredErrorToClear?: number[]
) => {
    setFields(prevState => {
        const updatedState = prevState.map((s, i) => {
            if (index === i) {
                return {
                    ...s,
                    value: newValue as string,
                    requiredError: ''
                }
            }
            if (otherIndexesRequiredErrorToClear && otherIndexesRequiredErrorToClear.length > 0 && otherIndexesRequiredErrorToClear.includes(i)) {
                return {
                    ...s,
                    error: '',
                    requiredError: ''
                }
            }
            return s; 
        })
        return updatedState;
    });
};

export const handleOnChangeEmail = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, 
    errorMsg: string, 
    errorMatchMsg: string,
    index: number,
    otherFieldIndex: number,
    otherFieldValue: string,
    setFields: Dispatch<SetStateAction<Field[]>>,
    ) => {
    const value = event.target.value; 
    setFields(prevState => {
        const updatedState = prevState.map((s, i) => {
            if (i === index) {
                return {
                    ...s,
                    value: value,
                    error: getEmailErrorText(errorMsg, errorMatchMsg, otherFieldIndex, otherFieldValue, value),
                    requiredError: ''
                }
            }
            if (otherFieldIndex === 3 && i === otherFieldIndex) {
                return {
                    ...s,
                    error: value !== otherFieldValue ? errorMatchMsg : ''
                }
            }
            return s; 
        })
        return updatedState;
    });
};

export const handleOnChangeSelect = (event: SelectChangeEvent<string>, index: number, setFields: Dispatch<SetStateAction<Field[]>>) => {
    setFields(prevState => {
        const updatedState = prevState.map((s, i) => {
            if (i === index) {
                return {
                    ...s,
                    value: event.target.value,
                    requiredError: ''
                }
            }
            return s; 
        })
        return updatedState;
    });
};

export const handleOnChangeText = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number, 
    setFields: Dispatch<SetStateAction<Field[]>>,
    validationType?: string,
    otherIndexesRequiredErrorToClear?: number[],
    otherIndexesValueToClear?: number[]
) => {
    let value = event.target.value; 
    if (validationType) {
        const regex = validationType === VALIDATION_TYPE.alphaNumeric
        ? REGEX.alphaNumeric
        : validationType === VALIDATION_TYPE.numeric
        ? REGEX.numeric
        : REGEX.nonNumeric;
                
        if (value && !regex.test(value)) {
            return;
        }

        if (validationType === VALIDATION_TYPE.alphaNumeric || validationType === VALIDATION_TYPE.nonNumeric) {
            value = value.toUpperCase();
        }
    }

    setFields(prevState => {
        const updatedState = prevState.map((s, i) => {
            if (i === index) {
                return {
                    ...s,
                    value: value,
                    error: '',
                    requiredError: ''
                }
            } 
            if (otherIndexesRequiredErrorToClear && otherIndexesRequiredErrorToClear.length > 0 && otherIndexesRequiredErrorToClear.includes(i)) {
                if(otherIndexesValueToClear && otherIndexesValueToClear.length > 0 && otherIndexesValueToClear.includes(i)) {
                    return {
                        ...s,
                        value: '',
                        error: '',
                        requiredError: ''
                    }
                }
                return {
                    ...s,
                    error: '',
                    requiredError: ''
                }
            }
            return s; 
        })
        return updatedState;
    });
};

export const handleOnValidateDate = (
    errorMessage: DateValidationError,
    index: number,
    setFields: Dispatch<SetStateAction<Field[]>>,
    validationErrorText: string
) => {
    setFields((prevState) => {
        const updatedState = prevState.map((state, i) => {
            if (index === i) {
                return {
                    ...state,
                    error: errorMessage ? validationErrorText : ''
                }
            } return state; 
        })
        return updatedState;
    });
};